/* eslint-disable */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : { default: e };
}

var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);

function toVal(mix) {
  var k,
    y,
    str = '';

  if (typeof mix === 'string' || typeof mix === 'number') {
    str += mix;
  } else if (typeof mix === 'object') {
    if (Array.isArray(mix)) {
      for (k = 0; k < mix.length; k++) {
        if (mix[k]) {
          if ((y = toVal(mix[k]))) {
            str && (str += ' ');
            str += y;
          }
        }
      }
    } else {
      for (k in mix) {
        if (mix[k]) {
          str && (str += ' ');
          str += k;
        }
      }
    }
  }

  return str;
}

function clsx() {
  var i = 0,
    tmp,
    x,
    str = '';
  while (i < arguments.length) {
    if ((tmp = arguments[i++])) {
      if ((x = toVal(tmp))) {
        str && (str += ' ');
        str += x;
      }
    }
  }
  return str;
}

var TARGET_BUTTON_ID = 'app-launcher_target-button';
var MENU_ID = 'app-launcher_menu-id';

var PasteIcon = function () {
  return React__default['default'].createElement(
    'svg',
    {
      width: '44',
      height: '44',
      viewBox: '0 0 44 44',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    React__default['default'].createElement('path', {
      d: 'M24.1365 11C15.2272 11 11.1885 13.1735 11.1885 20.5793C11.1994 21.1515 11.2468 21.7308 11.3235 22.303C11.6445 24.7392 12.677 26.5924 14.5267 27.7512C15.8802 28.6004 17.3469 28.9819 18.8464 29.2266C20.7034 29.5288 22.575 29.5648 24.4429 29.5792C25.0668 29.572 29.328 29.6512 31.3054 28.8487C33.9177 27.7871 35.9133 25.1926 35.9133 20.8888C35.9133 13.8105 32.3379 11 24.1365 11Z',
      fill: '#5115AA',
    }),
    React__default['default'].createElement('path', {
      d: 'M17.9016 19.7012C13.9395 19.7012 12.4364 20.1618 11.185 20.5792C9.3207 21.3601 8 22.9075 8 26.4196C8 31.6735 12.4072 33.336 19.412 33.336C22.5131 33.336 24.9903 32.1449 26.3183 29.5468C26.4679 29.2265 26.9349 28.0462 26.9349 26.2829C26.9349 21.7775 24.8553 19.7012 17.9016 19.7012Z',
      fill: '#FCCB58',
    }),
    React__default['default'].createElement('path', {
      d: 'M26.3182 29.5428C25.6943 29.5608 25.0704 29.5716 24.4466 29.5752C22.575 29.5608 17.4673 29.6579 14.5267 27.7471C12.6077 26.4984 11.2614 24.4868 11.1885 20.5752C12.4399 20.1578 13.943 19.6972 17.9051 19.6972C24.8552 19.7008 26.9347 21.7772 26.9347 26.2789C26.9347 28.0422 26.4641 29.2225 26.3182 29.5428Z',
      fill: '#F36464',
    })
  );
};
PasteIcon.displayName = 'PasteIcon';

var WeTransferIcon = function (_a) {
  var _b = _a.width,
    width = _b === void 0 ? 44 : _b,
    _c = _a.height,
    height = _c === void 0 ? 44 : _c,
    _d = _a.color,
    color = _d === void 0 ? '#161616' : _d;
  return React__default['default'].createElement(
    'svg',
    {
      width: width,
      height: height,
      viewBox: '0 0 44 44',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    React__default['default'].createElement('path', {
      d: 'M30.8059 28.9078C32.8715 28.9078 34.4312 28.2778 35.2743 27.3958C35.7099 26.9058 36.2298 26.1499 35.8645 25.5619C35.5413 25.0439 35.0073 24.9459 34.375 25.2679C33.7427 25.5899 33.026 25.7579 32.2111 25.7579C31.4242 25.7579 30.5951 25.4639 30.1455 25.0299C29.6115 24.4979 29.3164 23.8119 29.3164 22.9999C29.3164 22.8039 29.4429 22.7759 29.6537 22.9579C30.2157 23.3919 31.0448 23.6159 32.183 23.6159C34.2626 23.6159 36.1033 22.2299 36.1033 20.0739C36.1033 17.806 33.9394 16.112 30.6794 16.112C27.026 16.112 24.2017 18.4639 24.2017 22.4119C24.2157 26.0939 26.6607 28.9078 30.8059 28.9078Z',
      fill: color,
    }),
    React__default['default'].createElement('path', {
      d: 'M15.7284 25.0439C16.1218 25.0439 16.3466 25.2679 16.6136 25.6739L17.7939 27.5079C18.2295 28.2219 18.6089 28.7118 19.4661 28.7118C20.3232 28.7118 20.7167 28.3758 21.1382 27.4239C21.6581 26.2479 22.1921 24.8339 22.6839 22.9299C23.2179 20.8019 23.4708 19.486 23.4708 18.408C23.4708 17.33 23.1054 16.686 21.9251 16.462C20.3092 16.168 18.1312 16 15.7284 16C13.3255 16 11.1335 16.168 9.51757 16.462C8.33724 16.686 8 17.316 8 18.394C8 19.472 8.23888 20.7879 8.78689 22.9159C9.27869 24.8199 9.81265 26.2339 10.3326 27.4099C10.7541 28.3619 11.1476 28.6978 12.0047 28.6978C12.8618 28.6978 13.2272 28.2079 13.6768 27.4939L14.8572 25.6599C15.1101 25.2539 15.3349 25.0439 15.7284 25.0439Z',
      fill: color,
    })
  );
};
WeTransferIcon.displayName = 'WeTransferIcon';

var CollectIcon = function () {
  return React__default['default'].createElement(
    'svg',
    {
      width: '44',
      height: '44',
      viewBox: '0 0 44 44',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    React__default['default'].createElement('path', {
      d: 'M21.097 31.0173C21.097 33.8727 19.4007 35.8738 16.2876 35.8738C13.1745 35.8738 11.293 33.7525 11.293 31.0173C11.293 28.282 13.207 26.4531 16.1024 26.4531C18.9977 26.4531 21.097 27.9767 21.097 31.0173Z',
      fill: '#5115AA',
    }),
    React__default['default'].createElement('path', {
      d: 'M32.3523 10.2995C33.7464 11.94 33.7107 14.3764 33.285 16.4554C32.9373 18.1577 31.6732 18.9795 30.0646 18.4046C27.8972 17.6314 24.3454 14.4901 23.3022 12.6677C22.7856 11.7678 22.7856 10.0039 24.7386 9.40616C26.4543 8.87665 30.9583 8.659 32.3523 10.2995Z',
      fill: '#F9C346',
    }),
    React__default['default'].createElement('path', {
      d: 'M28.246 35.8753C32.3145 35.8753 33.5786 31.9836 33.5786 27.9586C33.5786 23.9337 32.282 20.042 28.246 20.042C24.2101 20.042 22.8972 23.9337 22.8972 27.9586C22.8972 31.9836 24.1776 35.8753 28.246 35.8753Z',
      fill: '#F36464',
    }),
    React__default['default'].createElement('path', {
      d: 'M16.1863 24.5507C11.2925 24.5507 11 21.1397 11 17.0498C11 12.9599 11.2762 9 16.1863 9C21.0965 9 21.3889 12.9599 21.3889 17.0498C21.3889 21.4776 21.077 24.5507 16.1863 24.5507Z',
      fill: '#FF904B',
    })
  );
};
CollectIcon.displayName = 'CollectIcon';

var WePresentIcon = function () {
  return React__default['default'].createElement(
    'svg',
    {
      width: '44',
      height: '44',
      viewBox: '0 0 44 44',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    React__default['default'].createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.2889 18.2459C10.8491 16.4935 10.5306 15.7966 10 15.0399V15H13.1694V15.0399C12.8811 15.6572 12.7748 16.8519 13.1388 18.3454L15.0951 26.4104L17.4456 18.6641L17.3242 18.2459C16.839 16.4935 16.5661 15.7966 16.0353 15.0399V15H19.2046V15.0399C18.9618 15.6175 18.7648 16.8519 19.1743 18.3454L21.2971 26.2511L23.0258 19.3213C23.587 17.0313 23.3141 15.677 22.9957 15.0399V15H25.1053L24.7811 15.0399C24.0684 16.0155 23.9206 16.9517 23.5112 18.6641L20.7664 29.736H20.4632L17.5971 19.2416L14.4431 29.736H14.1398L11.2889 18.2459Z',
      fill: 'black',
    }),
    React__default['default'].createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M25.5688 29.5767V29.5368C25.9631 28.342 26.1601 27.5255 26.1601 26.2114V18.3655C26.1601 17.0313 25.9631 16.2545 25.5688 15.0399V15H32.5745L33.1661 18.5447L33.0447 18.6043C32.2409 17.4892 31.1491 15.4978 30.4819 15.438L27.9192 15.2988V22.0294H29.2233C29.9664 22.0294 30.5729 20.6954 31.1038 19.9385H31.2401V24.4389H31.1038C30.6184 23.742 29.9512 22.4277 29.2233 22.4277H27.9192V29.2779L30.6184 29.1387C31.8618 29.0789 33.0295 27.1073 33.8786 25.5741L34 25.6339L33.3328 29.5767H25.5688Z',
      fill: 'black',
    })
  );
};
WePresentIcon.displayName = 'WePresentIcon';

exports.DEFAULT_APP_IDS = void 0;
(function (DEFAULT_APP_IDS) {
  DEFAULT_APP_IDS['WeTransfer'] = 'wetransfer';
  DEFAULT_APP_IDS['WePresent'] = 'wepresent';
  DEFAULT_APP_IDS['Paste'] = 'paste';
  DEFAULT_APP_IDS['Collect'] = 'collect';
})(exports.DEFAULT_APP_IDS || (exports.DEFAULT_APP_IDS = {}));
var WeTransfer = {
  description: 'Send files big and small',
  href: 'https://wetransfer.com',
  icon: WeTransferIcon,
  id: exports.DEFAULT_APP_IDS.WeTransfer,
  name: 'WeTransfer',
  openInNewTab: true,
};
var Paste = {
  description: 'Show and tell the work',
  href: 'https://pasteapp.com/',
  icon: PasteIcon,
  id: exports.DEFAULT_APP_IDS.Paste,
  name: 'Paste®',
  openInNewTab: true,
};
var Collect = {
  description: 'Save every inspiration',
  href: 'https://collect.wetransfer.com/',
  icon: CollectIcon,
  id: exports.DEFAULT_APP_IDS.Collect,
  name: 'Collect',
  openInNewTab: true,
};
var WePresent = {
  description: 'Stories about creativity',
  href: 'https://wepresent.wetransfer.com/',
  icon: WePresentIcon,
  id: exports.DEFAULT_APP_IDS.WePresent,
  name: 'WePresent',
  openInNewTab: true,
};
var DEFAULT_APPS = [WeTransfer, Paste, Collect, WePresent];

var styles = {
  AppLauncher: 'AppLauncher-module_AppLauncher__eHoUP',
  nav: 'AppLauncher-module_nav__1Jx9d',
  target: 'AppLauncher-module_target__3DZsl',
  mouseBridge: 'AppLauncher-module_mouseBridge__1Jj42',
  open: 'AppLauncher-module_open__no7_q',
  closed: 'AppLauncher-module_closed__3sfx8',
  list: 'AppLauncher-module_list__2rsI-',
  listItem: 'AppLauncher-module_listItem__3UrIE',
  icon: 'AppLauncher-module_icon__3jwLX',
  label: 'AppLauncher-module_label__2K2rp',
  name: 'AppLauncher-module_name__1PnUw',
  description: 'AppLauncher-module_description__2T7AI',
};

var AppLauncherContext = React.createContext({ isOpen: false });

var keyboardEventHasModfiers = function (event) {
  return event.altKey || event.shiftKey || event.metaKey || event.ctrlKey;
};

var AppLauncher = function (_a) {
  var _b = _a.apps,
    apps = _b === void 0 ? DEFAULT_APPS : _b,
    children = _a.children,
    currentAppId = _a.currentAppId,
    onNavigate = _a.onNavigate,
    onOpen = _a.onOpen,
    onClose = _a.onClose,
    appNameClassName = _a.appNameClassName,
    appDescriptionClassName = _a.appDescriptionClassName,
    className = _a.className,
    style = _a.style;
  // Validate props
  React__default['default'].useEffect(
    function () {
      if (!currentAppId) return;
      if (
        !apps.find(function (_a) {
          var id = _a.id;
          return currentAppId === id;
        })
      ) {
        throw new Error(
          "The prop 'currentAppId' (" +
            currentAppId +
            ") doesn't exist in prop 'apps'"
        );
      }
    },
    [apps, currentAppId]
  );
  // Open/Close
  var _c = React__default['default'].useState(false),
    isOpen = _c[0],
    setIsOpen = _c[1];
  var close = React__default['default'].useCallback(
    function () {
      if (!isOpen) return;
      setIsOpen(false);
      if (onClose) {
        onClose();
      }
    },
    [isOpen, onClose]
  );
  var open = React__default['default'].useCallback(
    function (shouldTrack) {
      if (isOpen) return;
      setIsOpen(true);
      if (shouldTrack && onOpen) {
        onOpen();
      }
    },
    [isOpen, onOpen]
  );
  // Focus management
  var targetRef = React__default['default'].useRef(null);
  var focusTargetButton = React__default['default'].useCallback(function () {
    var _a;
    var button =
      (_a = targetRef.current) === null || _a === void 0
        ? void 0
        : _a.firstElementChild;
    if (button && button instanceof HTMLButtonElement) {
      button.focus();
    }
  }, []);
  var listRef = React__default['default'].useRef(null);
  var _d = React__default['default'].useState(null),
    focusedLinkIndex = _d[0],
    setFocusedLinkIndex = _d[1];
  var focusLinkAtIndex = React__default['default'].useCallback(function (
    index
  ) {
    var _a;
    if (!listRef.current) return;
    var anchors = Array.from(listRef.current.querySelectorAll('a'));
    (_a = anchors[index]) === null || _a === void 0 ? void 0 : _a.focus();
  },
  []);
  // Events
  var handleTargetKeyDown = React__default['default'].useCallback(
    function (event) {
      if (keyboardEventHasModfiers(event)) return;
      switch (event.key) {
        case 'Enter':
        case ' ':
          if (isOpen) {
            setIsOpen(false);
            focusLinkAtIndex(apps.length - 1);
          } else {
            setIsOpen(true);
            focusLinkAtIndex(0);
          }
          event.preventDefault();
          break;
        case 'ArrowDown':
          setIsOpen(true);
          focusLinkAtIndex(0);
          event.preventDefault();
          break;
        case 'ArrowUp':
          setIsOpen(true);
          focusLinkAtIndex(apps.length - 1);
          event.preventDefault();
      }
    },
    [isOpen, focusLinkAtIndex]
  );
  var handleListKeyDown = React__default['default'].useCallback(
    function (event) {
      if (keyboardEventHasModfiers(event)) return;
      switch (event.key) {
        case 'ArrowUp':
          var prev = focusedLinkIndex - 1;
          focusLinkAtIndex(prev >= 0 ? prev : apps.length - 1);
          event.preventDefault();
          break;
        case 'ArrowDown':
          var next = focusedLinkIndex + 1;
          focusLinkAtIndex(next <= apps.length - 1 ? next : 0);
          event.preventDefault();
          break;
        case 'Escape':
          setIsOpen(false);
          focusTargetButton();
          event.preventDefault();
          break;
      }
    },
    [apps, isOpen, focusLinkAtIndex, focusedLinkIndex]
  );
  var handleLinkFocus = React__default['default'].useCallback(function (event) {
    if (!listRef.current) return;
    var anchors = Array.from(listRef.current.querySelectorAll('a'));
    var index = anchors.indexOf(event.target);
    setFocusedLinkIndex(index !== -1 ? index : null);
  }, []);
  var handleBlur = React__default['default'].useCallback(
    function (event) {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        setIsOpen(false);
      }
    },
    [isOpen]
  );
  var handleNavigate = React__default['default'].useCallback(
    function (app) {
      if (onNavigate) {
        onNavigate(app);
      }
    },
    [onNavigate]
  );
  return React__default['default'].createElement(
    AppLauncherContext.Provider,
    { value: { isOpen: isOpen } },
    React__default['default'].createElement(
      'div',
      {
        className: clsx(styles.AppLauncher, className),
        style: style,
        'aria-expanded': isOpen,
      },
      React__default['default'].createElement(
        'nav',
        { className: styles.nav, role: 'navigation' },
        React__default['default'].createElement(
          'div',
          {
            className: styles.target,
            onMouseOver: function () {
              return open(true);
            },
            onMouseLeave: close,
            onKeyDown: handleTargetKeyDown,
            ref: targetRef,
          },
          children,
          React__default['default'].createElement('div', {
            className: clsx(
              styles.mouseBridge,
              isOpen ? styles.open : styles.closed
            ),
          })
        ),
        React__default['default'].createElement(
          'ul',
          {
            className: clsx(styles.list, isOpen ? styles.open : styles.closed),
            onBlur: handleBlur,
            onMouseOver: function () {
              return open(false);
            },
            onMouseLeave: close,
            onKeyDown: handleListKeyDown,
            ref: listRef,
            'aria-labelledby': TARGET_BUTTON_ID,
            role: 'menu',
            tabIndex: -1,
            id: MENU_ID,
          },
          apps.map(function (app) {
            return React__default['default'].createElement(
              'li',
              { key: app.id, className: styles.listItem, role: 'none' },
              React__default['default'].createElement(
                'a',
                {
                  href: app.href,
                  onClick: function () {
                    return handleNavigate(app);
                  },
                  onFocus: handleLinkFocus,
                  rel: 'noreferrer noopener',
                  role: 'menuitem',
                  'aria-label': app.description
                    ? app.name + ': ' + app.description
                    : app.name,
                  tabIndex: -1,
                  target:
                    app.openInNewTab && currentAppId !== app.id
                      ? '_blank'
                      : undefined,
                  title: app.name,
                },
                React__default['default'].createElement(
                  'div',
                  { className: styles.icon, 'aria-hidden': true },
                  React__default['default'].createElement(app.icon, null)
                ),
                React__default['default'].createElement(
                  'div',
                  { className: styles.label, 'aria-hidden': true },
                  React__default['default'].createElement(
                    'div',
                    { className: clsx(styles.name, appNameClassName) },
                    app.name
                  ),
                  app.description
                    ? React__default['default'].createElement(
                        'div',
                        {
                          className: clsx(
                            styles.description,
                            appDescriptionClassName
                          ),
                        },
                        app.description
                      )
                    : null
                )
              )
            );
          })
        )
      )
    )
  );
};
AppLauncher.displayName = 'AppLauncher';

var WeTransferIcon$1 = function (_a) {
  var className = _a.className,
    style = _a.style,
    _b = _a.width,
    width = _b === void 0 ? 34 : _b,
    _c = _a.height,
    height = _c === void 0 ? 16 : _c,
    _d = _a.color,
    color = _d === void 0 ? '#FFFFFF' : _d;
  return React__default['default'].createElement(
    'svg',
    {
      width: width,
      height: height,
      viewBox: '0 0 34 16',
      fill: 'none',
      className: className,
      style: style,
      preserveAspectRatio: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    React__default['default'].createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.4136 11.9959C10.0873 11.4809 9.82024 11.2083 9.34554 11.2083C8.87085 11.2083 8.60383 11.4809 8.27748 11.9959L6.8534 14.2677C6.31937 15.1461 5.87434 15.752 4.83595 15.752C3.79755 15.752 3.32286 15.3279 2.8185 14.1465C2.19546 12.6926 1.54276 10.9357 0.949389 8.57293C0.296684 5.9371 0 4.30137 0 2.96855C0 1.63573 0.415357 0.848157 1.83944 0.575535C3.79755 0.212039 6.43804 0 9.34554 0C12.253 0 14.8935 0.212039 16.8516 0.575535C18.2757 0.848157 18.6911 1.63573 18.6911 2.96855C18.6911 4.30137 18.3944 5.9371 17.7417 8.57293C17.1483 10.9357 16.4956 12.6926 15.8726 14.1465C15.3682 15.3279 14.8935 15.752 13.8551 15.752C12.8167 15.752 12.3717 15.1461 11.8377 14.2677L10.4136 11.9959ZM32.9913 14.122C31.9826 15.2124 30.0838 16 27.5917 16C22.5777 16 19.6108 12.5165 19.6108 7.94252C19.6108 3.03532 23.0227 0.12735 27.4433 0.12735C31.3892 0.12735 34 2.21745 34 5.03455C34 7.70019 31.7749 9.42679 29.2531 9.42679C27.8883 9.42679 26.8796 9.15417 26.1972 8.60893C25.9302 8.39689 25.7819 8.42718 25.7819 8.66951C25.7819 9.66912 26.1379 10.5173 26.7906 11.1837C27.3246 11.7289 28.3334 12.0924 29.2828 12.0924C30.2618 12.0924 31.1222 11.8804 31.8936 11.4866C32.665 11.0928 33.3177 11.214 33.7034 11.8501C34.1484 12.5771 33.5254 13.5161 32.9913 14.122Z',
      fill: color,
    })
  );
};
WeTransferIcon$1.displayName = 'WeTransferIcon';

var CaretIcon = function (_a) {
  var className = _a.className,
    _b = _a.width,
    width = _b === void 0 ? 10 : _b,
    _c = _a.height,
    height = _c === void 0 ? 6 : _c,
    _d = _a.color,
    color = _d === void 0 ? 'white' : _d;
  return React__default['default'].createElement(
    'svg',
    {
      width: width,
      height: height,
      viewBox: '0 0 10 6',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      className: className,
    },
    React__default['default'].createElement('path', {
      d: 'M9.70711 0.292893C10.0976 0.683417 10.0976 1.31658 9.70711 1.70711L5.70711 5.70711C5.31658 6.09763 4.68342 6.09763 4.29289 5.70711L0.292893 1.70711C-0.0976315 1.31658 -0.0976315 0.683417 0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L5 3.58579L8.29289 0.292893C8.68342 -0.0976311 9.31658 -0.0976311 9.70711 0.292893Z',
      fill: color,
    })
  );
};
CaretIcon.displayName = 'CaretIcon';

var CoreShape = function (_a) {
  var className = _a.className,
    style = _a.style,
    _b = _a.color,
    color = _b === void 0 ? '#FFFFFF' : _b;
  return React__default['default'].createElement(
    'svg',
    {
      width: '70',
      height: '42',
      viewBox: '0 0 70 42',
      fill: 'none',
      className: className,
      style: style,
      preserveAspectRatio: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      'aria-hidden': true,
    },
    React__default['default'].createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M-9.17867e-07 20.9984C-9.188e-07 21.0197 -9.1966e-07 21.0394 -9.20521e-07 21.0591C-9.21381e-07 21.0787 -9.22242e-07 21.0984 -9.23102e-07 21.1181L0.00175384 21.1181C0.0916807 39.0581 13.8109 42.0358 35.0335 41.9997C56.2543 41.9636 69.9665 38.94 69.9982 21.0016L70 21.0016C70 20.9803 70 20.9606 70 20.9409C70 20.9213 70 20.9016 70 20.8819L69.9982 20.8819C69.9083 2.94192 56.1891 -0.0356109 34.9665 0.000317265C13.7439 0.0347689 0.0334853 3.06003 -9.17867e-07 20.9984Z',
      fill: color,
    })
  );
};
CoreShape.displayName = 'CoreShape';

var styles$1 = {
  LauncherButton: 'LauncherButton-module_LauncherButton__1a085',
  pill: 'LauncherButton-module_pill__1gsiL',
  expanded: 'LauncherButton-module_expanded__3NvGy',
  caret: 'LauncherButton-module_caret__28Qif',
};

var LauncherButton = function () {
  var isOpen = React__default['default'].useContext(AppLauncherContext).isOpen;
  return React__default['default'].createElement(
    'button',
    {
      'aria-controls': MENU_ID,
      'aria-expanded': isOpen,
      'aria-haspopup': 'true',
      'aria-label': 'WeTransfer apps',
      className: styles$1.LauncherButton,
      id: TARGET_BUTTON_ID,
      tabIndex: 0,
    },
    React__default['default'].createElement(CoreShape, {
      className: clsx(styles$1.pill, isOpen && styles$1.expanded),
      color: 'rgba(0,0,0,0.15)',
    }),
    React__default['default'].createElement(WeTransferIcon$1, {
      width: 34,
      height: 16,
      color: 'white',
    }),
    React__default['default'].createElement(CaretIcon, {
      className: styles$1.caret,
    })
  );
};
LauncherButton.displayName = 'LauncherButton';

exports.AppLauncher = AppLauncher;
exports.AppLauncherContext = AppLauncherContext;
exports.Collect = Collect;
exports.CollectIcon = CollectIcon;
exports.DEFAULT_APPS = DEFAULT_APPS;
exports.LauncherButton = LauncherButton;
exports.MENU_ID = MENU_ID;
exports.Paste = Paste;
exports.PasteIcon = PasteIcon;
exports.TARGET_BUTTON_ID = TARGET_BUTTON_ID;
exports.WePresent = WePresent;
exports.WePresentIcon = WePresentIcon;
exports.WeTransfer = WeTransfer;
exports.WeTransferIcon = WeTransferIcon;
//# sourceMappingURL=index.js.map

module.exports = exports;
